// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7a3644f9","977":"62e42d88"}[chunkId] + ".chunk.js";
};